"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Import */
const auth_1 = require("./modules/auth");
const button_1 = require("./modules/button");
const autotrigger_1 = require("./modules/autotrigger");
const cookie_1 = require("./modules/cookie");
const hotkey_1 = require("./modules/hotkey");
const helper_1 = require("./modules/helper");
const modal_1 = require("./modules/modal");
const analytics_1 = require("./modules/analytics");
/** AdBlock Detect Library */
/** FAB PLUGIN */
window.FAB_PLUGIN = Object.assign(Object.assign({}, window.FAB_PLUGIN), { 
    /** Initiate FAB Plugin */
    init: () => {
        /** Instantiate */
        window.FAB_PLUGIN.modules = {
            auth: new auth_1.FABAuth(),
            autotrigger: new autotrigger_1.FABAutotrigger(),
            button: new button_1.FABButton(),
            cookie: new cookie_1.FABCookie(),
            hotkey: new hotkey_1.FABHotkey(),
            helper: new helper_1.FABHelper(),
            modal: new modal_1.FABModal(),
            analytics: new analytics_1.FABAnalytics(),
        };
        /** Initiate */
        Object.keys(window.FAB_PLUGIN.modules).forEach((key) => {
            try {
                window.FAB_PLUGIN.modules[key].init();
            }
            catch (err) { }
        });
    }, 
    /**
     * Animate UI Component
     * @params     object      Selector object that would like to be animated
     * @params     string      Type of animation in a form of string class 'animated bounce'
     * */
    animate: (selector, animation) => {
        jQuery(selector).addClass(animation);
        jQuery(selector).on('animationend', () => { jQuery(selector).removeClass(animation); });
        return jQuery(selector);
    } });
jQuery(document).ready(function ($) {
    /** Initiate */
    jQuery('#fab-checkbox').prop('checked', false);
    window.FAB_PLUGIN.init();
});
